import 'twin.macro';

import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { PURGE } from 'redux-persist';

import { ThemeContext } from '@/contexts/theme-context';
import LandingBanner from '@/views/info-landing/landing-banner';
import LandingCardTypes from '@/views/info-landing/landing-card-types';
import LandingInfoBlock1 from '@/views/info-landing/landing-info-block1';
import LandingInfoBlock2 from '@/views/info-landing/landing-info-block2';
import LandingInfoBlock3 from '@/views/info-landing/landing-info-block3';

function InfoLanding() {
  const [open, setOpen] = useState(false);
  const { theme, setTheme } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch({ type: PURGE, result: () => null });
  }, [dispatch]);

  useEffect(() => {
    setTheme('dark');
  }, [setTheme]);

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <LandingBanner setOpen={setOpen} />
      <LandingCardTypes />
      <LandingInfoBlock1 />
      <LandingInfoBlock2 />
      <LandingInfoBlock3 />
    </>
  );
}

export default InfoLanding;
